var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48822 1.00855C9.78915 0.774495 10.2105 0.774495 10.5115 1.00855L18.0115 6.84188C18.2144 6.99976 18.3332 7.24252 18.3332 7.49967V16.6663C18.3332 17.3294 18.0698 17.9653 17.6009 18.4341C17.1321 18.9029 16.4962 19.1663 15.8332 19.1663H4.1665C3.50346 19.1663 2.86758 18.9029 2.39874 18.4341C1.9299 17.9653 1.6665 17.3294 1.6665 16.6663V7.49967C1.6665 7.24252 1.78523 6.99976 1.98822 6.84188L9.48822 1.00855ZM3.33317 7.90724V16.6663C3.33317 16.8874 3.42097 17.0993 3.57725 17.2556C3.73353 17.4119 3.94549 17.4997 4.1665 17.4997H15.8332C16.0542 17.4997 16.2661 17.4119 16.4224 17.2556C16.5787 17.0993 16.6665 16.8874 16.6665 16.6663V7.90724L9.99984 2.72206L3.33317 7.90724Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 10.0003C6.6665 9.54009 7.0396 9.16699 7.49984 9.16699H12.4998C12.9601 9.16699 13.3332 9.54009 13.3332 10.0003V18.3337C13.3332 18.7939 12.9601 19.167 12.4998 19.167C12.0396 19.167 11.6665 18.7939 11.6665 18.3337V10.8337H8.33317V18.3337C8.33317 18.7939 7.96007 19.167 7.49984 19.167C7.0396 19.167 6.6665 18.7939 6.6665 18.3337V10.0003Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2e71db4022da443bfdf0e0bdd7475bbe.svg";
export { ForwardRef as ReactComponent };